import type { ReactNode } from 'react'

export function PrivateLayoutCardWrapper({
  children,
}: {
  children: ReactNode
}) {
  return (
    <div className="h-full bg-white lg:p-2">
      <div className="flex h-full flex-col items-center justify-center rounded-lg bg-document">
        {children}
      </div>
    </div>
  )
}
